<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
        <ion-title>
          EVENTOS
        </ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content class="mb-5">
      <ion-refresher slot="fixed" @ionRefresh="recargarEventos($event);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button @click="muestraModalNuevoEvento();" color="secondary">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
      </ion-fab>

      <ion-card v-for="evento in eventos" :key="evento.evt_id" :color="evento.color" style="cursor:pointer;" @click="muestraModalEvento(evento)">
        <div class="container-fluid p-3">
          <div class="row" style="font-size:small;">
            <div class="col">Ticket {{ evento.evt_id }}</div>
            <div class="col text-right">
              <ion-label>
                {{  
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[2] + '/' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[1] + '/' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[0] + ' ' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[0] + ':' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[1]
                }}
              </ion-label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h5 class="ion-text-start ion-no-padding ion-no-margin">
                <fa v-if="evento.tev_prioridad == 1" :icon="['fas', 'exclamation-circle']"  ></fa>
                <fa v-if="evento.tev_prioridad == 2" :icon="['fas', 'exclamation-triangle']"></fa>
                <fa v-if="evento.tev_prioridad == 3" :icon="['fas', 'exclamation']"  ></fa>
                {{evento.tev_tipo}}
              </h5>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-7">
              <ion-label>
                <span v-if="evento.grupo == 0">{{ /* evento.evt_empresa_origen+' | '+ */evento.evt_sucursal_origen }}</span>
                <span v-else class="font-weight-bold">Falla masiva</span>
              </ion-label>
            </div>
            <div class="col-5 text-right font-weight-bold">
              <ion-label><fa v-if="evento.estado_actual.tpe_id==1 && evento.estados.length > 1" class="fa-fw mr-1" :icon="['fad', 'repeat']"></fa><span>{{evento.estado_actual.tpe_estado}}</span></ion-label>
            </div>
          </div>
        </div>
      </ion-card>
      <div class="mb-5 mt-5 p-3"></div>
      <div v-if="eventos.length == 0" class="row mt-3">
        <div class="col text-center">
          SIN REGISTROS PARA LISTAR.
        </div>
      </div>
      
    </ion-content>
    
  </ion-page>
</template>

<script>
import { 
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonMenuButton, IonButtons, IonLabel, toastController, IonCard, 
  IonRefresher, IonRefresherContent, modalController, loadingController, isPlatform, IonIcon, IonFab, IonFabButton
} from '@ionic/vue';

import { addIcons         } from 'ionicons';
import { closeOutline, alertCircleOutline, add } from 'ionicons/icons';
import { defineComponent  } from 'vue';
import { Preferences      } from '@capacitor/preferences';
import { App              } from '@capacitor/app';

import { cerrarSesion    } from '@/plugins/funciones.ts';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';
import mEvento             from '../../components/ModalEvento.vue';
import mNuevoEvento        from './ModalNuevoEvento.vue';

export default defineComponent({
  name: 'Eventos',
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonMenuButton, IonButtons, IonLabel, IonCard, IonRefresher, 
    IonRefresherContent, IonIcon, IonFab, IonFabButton
  },
  data() {
    return { 
      eventos           : [],
      modalEvento       : null,
      modalNuevoEvento  : null,
      esMovil           : false
    }
  },
  created() {
    addIcons({
      'close-outline'         : closeOutline,
      'alert-circle-outline'  : alertCircleOutline,
      'add'                   : add
    });
  },
  mounted(){
    this.detectaPlataforma();
    this.listarEventos();
    this.intervaloEventos = setInterval(this.recargarEventos, 10000);
  },
  unmounted() {
    clearInterval(this.intervaloEventos); 
  },
  methods: {
    detectaPlataforma(){
      if((isPlatform('ios') || isPlatform('android') || isPlatform('mobile')) || !isPlatform('mobileweb') && !isPlatform('desktop')){
        this.esMovil = true;
        // Si la app vuelve a primer plano, reactivar el intervalo de recarga.
        App.addListener('appStateChange', async (state) => {
          if (state.isActive){
            this.intervaloEventos = setInterval(this.recargarEventos, 10000);
            this.recargarEventos();
          }
          else{
            clearInterval(this.intervaloEventos); 
          }
        });
      }
      else{
        this.esMovil = false;
      } 
    },

    async muestraModalCargando(){
      this.modalCargando = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : false,
          mode      : 'md'
        });
      await this.modalCargando.present();
    },

    async listarEventos(){
      await this.muestraModalCargando();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/listarEventos', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.eventos = resp.data.eventos;
        this.modalCargando.dismiss();
      }).catch(() =>{
        this.modalCargando.dismiss();
        this.muestraToast('Error al listar eventos.');
      });
    },

    async recargarEventos(evento=false){
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/listarEventos', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.eventos = resp.data.eventos;
        if(evento){ evento.target.complete(); }
      }).catch(() =>{
        if(evento){ evento.target.complete(); }
        this.muestraToast('Error al recargar eventos.');
      });
    },

    async muestraModalEvento(evento){
      this.modalEvento = await modalController
        .create({
          component       : mEvento,
          //backdropDismiss : false,
          componentProps  : {
            propEvento    : evento,
            modal         : this.modalEvento,
          }
        });
      this.modalEvento.present();
      const modalResponse = await this.modalEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      const datos = _value;
      if(datos.recargar){
        this.listarEventos();
      }
    },

    async muestraModalNuevoEvento(){
      this.modalNuevoEvento = await modalController
        .create({
          component: mNuevoEvento,
          componentProps  : {
            esMovil       : this.esMovil
          },
          backdropDismiss: false
        });
      this.modalNuevoEvento.present();
      const modalResponse = await this.modalNuevoEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>
